<div *ngIf="order">
  <div class="d-flex flex-row justify-content-between align-items-center mb-4 mt-4">
    <div>
      <h2 *ngIf="order.extra.oh.ordstat !== 0">Order {{ order.id }}</h2>
      <h2 *ngIf="order.extra.oh.ordstat === 0">Quote {{ order.id }}</h2>
      <h6 *ngIf="order.extra.deliveryCustomer">{{ order.extra.deliveryCustomer.name }}</h6>
    </div>
    <div>
      <div
        ngbDropdown
        class="d-inline-block mr-2 dropdown"
        *ngIf="order.extra?.deliveries_logtrade && order.extra.deliveries_logtrade.length > 0"
      >
        <button
          type="button"
          class="dropdown-toggle btn btn-outline-primary"
          id="dropdownTrack"
          ngbDropdownToggle
          translate
        >
          TRACK_ORDER
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownTrack">
          <button
            ngbDropdownItem
            *ngFor="let item of order.extra.deliveries_logtrade; let i = index"
            (click)="goToPage(item.shipmentno)"
          >
            <span translate>TRACKING</span>&nbsp;{{ i + 1 }}
          </button>
        </div>
      </div>
      <lib-action-btn [item]="order" [config]="configService"></lib-action-btn>
    </div>
  </div>

  <div class="row mb-3">
    <div class="col">
      <lib-gung-accordion #acc="gungAccordion" activeIds="ngb-panel-0">
        <lib-gung-accordion-item>
          <ng-template libGungAccordionHeader>{{'DETAILS_AND_CONDITIONS' | translate}}</ng-template>
          <ng-template libGungAccordionBody>
            <div class="row">
              <div class="col col-xs-12 col-md-6">
                <h5>{{ 'DETAILS' | translate }}</h5>
                <lib-gung-text-input-horizontal
                  renderStatic="true"
                  gungTranslate="ORDER_NUMBER"
                  [(ngModel)]="order.extra.oh.ordernr"
                >
                </lib-gung-text-input-horizontal>
                <lib-gung-text-input-horizontal
                  renderStatic="true"
                  gungTranslate="YOUR_REFERENCE_NO"
                  [(ngModel)]="order.extra.oh.kundbestnr"
                ></lib-gung-text-input-horizontal>
                <lib-gung-meta-output
                  [value]="order.extra.oh.ordstat"
                  [gungTranslate]="'ORDER_STATUS'"
                  metadataTable="x7"
                  metaOptionName="ordstatbeskr"
                  [horizontal]="true"
                ></lib-gung-meta-output>
                <lib-gung-date-output
                  [horizontal]="true"
                  [gungTranslate]="'ORDER_DATE'"
                  [value]="order.extra.oh.orddatum"
                >
                </lib-gung-date-output>
                <lib-gung-date-output
                  [horizontal]="true"
                  [gungTranslate]="'ESTIMATED_DELIVERY_DATE'"
                  [value]="order.extra.oh.ordberlevdat"
                >
                </lib-gung-date-output>
              </div>
              <div class="col col-xs-12 col-md-6">
                <h5>{{ 'CONDITIONS' | translate }}</h5>
                <lib-gung-meta-output
                  [horizontal]="true"
                  [gungTranslate]="'PAYMENT_TERMS'"
                  [value]="order.extra.oh.betkod"
                  metadataTable="x2"
                  metaOptionName="betvillbeskr"
                >
                </lib-gung-meta-output>
                <lib-gung-meta-output
                  [horizontal]="true"
                  [gungTranslate]="'DELIVERY_TERMS'"
                  [value]="order.extra.oh.levvillkkod"
                  metadataTable="x2e"
                  metaOptionName="levvillkbeskr"
                >
                </lib-gung-meta-output>
                <lib-gung-meta-output
                  [horizontal]="true"
                  [gungTranslate]="'DELIVERY_METHOD'"
                  [value]="order.extra.oh.levsattkod"
                  metadataTable="x2f"
                  metaOptionName="levsattbeskr"
                >
                </lib-gung-meta-output>
              </div>
            </div>
          </ng-template>
        </lib-gung-accordion-item>
        <lib-gung-accordion-item>
          <ng-template libGungAccordionHeader>{{'SHIPPING_INFORMATION' | translate}}</ng-template>
          <ng-template libGungAccordionBody>
            <div class="row">
              <div class="col col-12">
                <h5>{{ 'ADDRESS' | translate }}</h5>
              </div>
              <div class="col col-xs-12 col-md-6">
                <lib-gung-text-input-horizontal
                  renderStatic="true"
                  gungTranslate="CUSTOMER_REFERENCE"
                  [(ngModel)]="order.extra.oh.kundref2"
                ></lib-gung-text-input-horizontal>
                <lib-gung-text-input-horizontal
                  renderStatic="true"
                  gungTranslate="ADDRESS1"
                  [(ngModel)]="order.extra.oh.ordlevadr2"
                ></lib-gung-text-input-horizontal>
                <lib-gung-text-input-horizontal
                  renderStatic="true"
                  gungTranslate="ADDRESS2"
                  [(ngModel)]="order.extra.oh.ordlevadr3"
                ></lib-gung-text-input-horizontal>
              </div>
              <div class="col col-xs-12 col-md-6">
                <lib-gung-text-input-horizontal
                  renderStatic="true"
                  gungTranslate="CITY"
                  [(ngModel)]="order.extra.oh.ordlevadr4"
                ></lib-gung-text-input-horizontal>
                <lib-gung-text-input-horizontal
                  *ngIf="order.extra.oh.ftgpostnr"
                  renderStatic="true"
                  gungTranslate="ZIP"
                  [(ngModel)]="order.extra.oh.ftgpostnr"
                >
                </lib-gung-text-input-horizontal>
                <lib-gung-meta-output
                  [horizontal]="true"
                  [gungTranslate]="'COUNTRY'"
                  [value]="order.extra.oh.ordlevadrlandskod"
                  metadataTable="xr"
                  metaOptionName="land"
                >
                </lib-gung-meta-output>
              </div>
            </div>
          </ng-template>
        </lib-gung-accordion-item>
        <lib-gung-accordion-item>
          <ng-template libGungAccordionHeader>{{'ADDITIONAL_INFORMATION' | translate}}</ng-template>
          <ng-template libGungAccordionBody>
            <div class="form-group row">
              <label for="oh.editext" class="col-form-label text-right-sm text-muted col-xs-12 col-sm-4"
                >{{ 'MESSAGE' | translate }}</label
              >
              <div class="col">
                <textarea
                  class="form-control"
                  type="text"
                  name="editext"
                  id="oh.editext"
                  disabled="true"
                  [(ngModel)]="order.extra.oh.editext"
                ></textarea>
              </div>
            </div>
            <div class="form-group row" *ngIf="isSales">
              <label for="oh.edit" class="col-form-label text-right-sm text-muted col-xs-12 col-sm-4"
                >{{ 'INTERNAL_TEXT' | translate }}</label
              >
              <div class="col">
                <textarea
                  class="form-control"
                  type="text"
                  name="edit"
                  id="oh.edit"
                  disabled="true"
                  [(ngModel)]="order.extra.oh.edit"
                ></textarea>
              </div>
            </div>
          </ng-template>
        </lib-gung-accordion-item>
      </lib-gung-accordion>
    </div>
  </div>

  <div class="row">
    <div class="col-12 table-responsive gung-responsive">
      <table class="table table-striped">
        <thead>
          <tr>
            <th translate>PRODUCT_ID</th>
            <th translate>NAME</th>
            <th translate>ESTIMATED_DELIVERY_DATE</th>
            <th translate>QUANTITY</th>
            <th translate>QUANTITY_DELIVERED</th>
            <th translate>QUANTITY_BACKORDER</th>
            <th *ngIf="!isReturNoPrice" translate>UNIT_PRICE</th>
            <th *ngIf="!isReturNoPrice" translate>DISCOUNT</th>
            <th *ngIf="!isReturNoPrice" translate>TOTAL_PRICE</th>
            <th *ngIf="order.extra.oh.ordstat === 0 && isSales"></th>
          </tr>
        </thead>
        <tbody *ngIf="order">
          <tr *ngFor="let row of order.rows" [ngClass]="row.extra.orp.ordradst === 90 ? 'deleted' : ''">
            <td [attr.data-label]="'PRODUCT_ID' | translate">
              <a [routerLink]="['/product/', row.productId]">{{ row.productId }}</a>
            </td>
            <td [attr.data-label]="'NAME' | translate">
              <a [routerLink]="['/product/', row.productId]">
                <span *ngIf="row.extra.orp.artbeskr">
                  {{ row.extra.orp.artbeskr }}
                </span>
                <span *ngIf="this.products && this.products[row.productId] && !row.extra.orp.artbeskr">
                  {{ this.products[row.productId].name }}
                </span>
              </a>
            </td>
            <td [attr.data-label]="'ESTIMATED_DELIVERY_DATE' | translate">
              {{ row.extra.orp.ordberlevdat | date : dateUtilService.dateFormat }}
            </td>
            <td [attr.data-label]="'QUANTITY' | translate">
              {{ row.quantity }}
            </td>
            <td [attr.data-label]="'QUANTITY_DELIVERED' | translate">
              {{ row.extra.orp.ordlevantal }}
            </td>
            <td [attr.data-label]="'QUANTITY_BACKORDER' | translate">
              {{ row.extra.orp.ordrestant }}
            </td>
            <ng-container *ngIf="!isReturNoPrice">
              <td [attr.data-label]="'UNIT_PRICE' | translate">
                <lib-price [price]="row.extra.orp.vb_pris" [currency]="order.extra.oh.valkod"></lib-price>
              </td>
              <td [attr.data-label]="'DISCOUNT' | translate">{{ row.extra.orp.ordradrab | number : '1.0-2' }}%</td>
              <td [attr.data-label]="'TOTAL_PRICE' | translate">
                <lib-price [price]="row.extra.orp.vbordradsum" [currency]="order.extra.oh.valkod"></lib-price>
              </td>
            </ng-container>
            <td *ngIf="isOrderEditable(order, isSales)">
              <gung-jeeves-edit-orderrow-modal (orderRowChange)="orderUpdated($event)" [orderRow]="row">
              </gung-jeeves-edit-orderrow-modal>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="col-12" *ngIf="isOrderEditable(order, isSales)">
      <button class="btn btn-primary btn-block" (click)="addRow()" translate>ADD_ROW</button>
    </div>
  </div>
</div>
